<template>
  <div class="gff">
    <main>
      <PagesSlider
        v-if="PageContent.banners && PageContent.banners.length"
        :title="PageContent.title"
        :banners="PageContent.banners"
        :color="PageContent.color"
        :noHost="true"
      />
      <section class="therapy-areas failure-page__section">
        <div class="content">
          <div class="failure-page__row">
            <div class="failure-page__categories">
              <div
                class="failure-page__title"
                v-if="PageContent.name"
                v-html="PageContent.name"
              ></div>
              <div
                ref="description"
                class="failure-page__description"
                v-html="PageContent.description"
              ></div>
              <div class="failure-page__categories-row">
                <InfoDrop
                  v-for="(info, ind) in PageContent.content"
                  :key="ind"
                  @clickOpener="clickOpener"
                  :color="PageContent.color"
                  :item="info"
                  :auth="
                    typeof info.auth !== 'undefined'
                      ? info.auth
                      : typeof $route.meta.closed !== 'undefined'
                      ? user &&
                        !Object.keys(user).length &&
                        !$route.query.access
                      : false
                  "
                />
              </div>
            </div>
            <RightAside
              @medicationsClick="medicationsClick"
              @calendarClick="calendarClick"
              @libClick="libClick"
              v-if="
                asideItems && asideItems.length && PageContent.content.length
              "
              :items="asideItems"
              class="failure-page__aside"
            />
          </div>
        </div>
        <PopupEnd
          :eventName="'gff'"
          :backUrl="{ name: 'GFF' }"
          @close="closePopup"
          v-if="popup"
        />
      </section>
    </main>
  </div>
</template>

<script>
import AsideBlock from "@/components/pageComponents/AsideBlock.vue";
import Breadcrumbs from "@/components/pageComponents/Breadcrumbs.vue";
import InfoDrop from "@/components/pageComponents/InfoDrop.vue";
import PagesSlider from "@/components/main/PagesSlider.vue";
import RightAside from "@/components/pageComponents/RightAside.vue";
import PopupEnd from "@/components/pageComponents/PopUpEventEnd.vue";
import { mapGetters } from "vuex";

export default {
  metaInfo() {
    return { title: "Дефицит лизосомной кислой липазы: Вопросы и ответы" };
  },
  components: {
    Breadcrumbs,
    AsideBlock,
    InfoDrop,
    PagesSlider,
    RightAside,
    PopupEnd,
  },
  name: "Lald",
  data: (vm) => ({
    popup: false,
    items: [],
    index: null,
    media: {
      mobile: 767,
      tablet: 1220,
      desktop: 1919,
      desktop_l: 2559,
      desktop_xl: 3839,
      desktop_xxl: 9999999,
    },
  }),
  computed: {
    ...mapGetters(["user"]),
    asideItems() {
      if (this.PageContent && Object.keys(this.PageContent).length) {
        return [
          {
            title: "Препараты АЗ",
            // descr: this.Disease.parent.title,
            image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-1_small.jpg`,
            image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-1.jpg`,
            theme: "white",
            event: "medicationsClick",
            to: {
              name: "Medications",
              query: {
                therapeutic_areas: "rare-diseases",
                disease: "gipofosfataziya-gff",
              },
            },
          },
          {
            title: "Мероприятия",
            image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-2.jpg`,
            image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-2_small.jpg`,
            links: [
              {
                event: "calendarClick",
                title: "Предстоящие",
                to: {
                  name: "Events",
                  query: {
                    therapeutic_areas: "rare-diseases",
                  },
                },
              },
              {
                event: "calendarClick",
                title: "Архив",
                to: {
                  name: "ArchiveEvents",
                  query: {
                    therapeutic_areas: "rare-diseases",
                    disease: "gipofosfataziya-gff",
                  },
                },
              },
            ],
          },
          {
            title: "Библиотека",
            image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-3.jpg`,
            image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-3_small.jpg`,
            links: [
              {
                event: "libClick",
                title: "Публикации",
                to: {
                  name: "TextMaterials",
                },
              },
              {
                event: "libClick",
                title: "Видеоматериалы",
                to: {
                  name: "VideoMaterials",
                },
              },
              {
                event: "libClick",
                title: "Подкасты",
                to: {
                  name: "Podcasts",
                },
              },
            ],
            theme: "dark",
          },
        ];
      } else {
        return [];
      }
    },
    PageContent() {
      return {
        id: 11,
        content: [
          {
            title:
              "Что такое Гипофосфатазия и чем это заболевание отличается от рахита?",
            content: `<div class='text-1'>Гипофосфатазия - жизнеугрожающее системное наследственное метаболическое заболевание, вызванное мутацией в гене ALPL, что приводит к дефициту щелочной фосфатазы.<sup>1</sup> Системные проявления Гипофосфатазии непредсказуемы. Признаки и симптомы заболевания у пациента возможны не только со стороны костной системы, но и со стороны дыхательной, нервной, мышечной систем, а также со стороны почек и зубов. Низкий уровень ЩФ позволяет правильно провести дифференциальную диагностику с другими заболеваниями костной системы.<sup>2</sup></div><br><br><div class="overflow mb-4"><table><thead style="background-color:#005f5b"><tr><td style="text-align:center">Показатель</td><td style="text-align:center" colspan="4">Заболевания</td></tr></thead><tbody><tr><td style="text-align:center"></td><td style="text-align:center;color:#80ac58">Гипофосфатазия</td><td style="text-align:center">Рахит</td><td style="text-align:center">Фосфат-диабет</td><td style="text-align:center">Несовершенный остеогенез</td></tr><tr><td style="text-align:center">ЩФ в крови</td><td style="text-align:center"><svg class="d-inline" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.29289 16.7072C7.68342 17.0978 8.31658 17.0978 8.70711 16.7072L15.0711 10.3433C15.4616 9.95274 15.4616 9.31958 15.0711 8.92905C14.6805 8.53853 14.0474 8.53853 13.6569 8.92905L8 14.5859L2.34315 8.92905C1.95262 8.53853 1.31946 8.53853 0.928933 8.92905C0.538408 9.31958 0.538408 9.95274 0.928933 10.3433L7.29289 16.7072ZM7 0.000122114L7 16.0001L9 16.0001L9 0.000122027L7 0.000122114Z" fill="#80AC58"/></svg></td><td style="text-align:center"><svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.20711 0.293015C7.81658 -0.0975094 7.18342 -0.0975094 6.79289 0.293015L0.428932 6.65698C0.0384079 7.0475 0.0384079 7.68067 0.428932 8.07119C0.819457 8.46171 1.45262 8.46171 1.84315 8.07119L7.5 2.41434L13.1569 8.07119C13.5474 8.46171 14.1805 8.46171 14.5711 8.07119C14.9616 7.68067 14.9616 7.0475 14.5711 6.65698L8.20711 0.293015ZM8.5 17.0001L8.5 1.00012L6.5 1.00012L6.5 17.0001L8.5 17.0001Z" fill="#3C4242"/></svg></td><td style="text-align:center"><svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.20711 0.293015C7.81658 -0.0975094 7.18342 -0.0975094 6.79289 0.293015L0.428932 6.65698C0.0384079 7.0475 0.0384079 7.68067 0.428932 8.07119C0.819457 8.46171 1.45262 8.46171 1.84315 8.07119L7.5 2.41434L13.1569 8.07119C13.5474 8.46171 14.1805 8.46171 14.5711 8.07119C14.9616 7.68067 14.9616 7.0475 14.5711 6.65698L8.20711 0.293015ZM8.5 17.0001L8.5 1.00012L6.5 1.00012L6.5 17.0001L8.5 17.0001Z" fill="#3C4242"/></svg></td><td style="text-align:center">норма</td></tr><tr><td style="text-align:center">Кальций/фосфор в крови</td><td style="text-align:center;color:#80ac58"><svg class="d-inline" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.29289 16.7072C7.68342 17.0978 8.31658 17.0978 8.70711 16.7072L15.0711 10.3433C15.4616 9.95274 15.4616 9.31958 15.0711 8.92905C14.6805 8.53853 14.0474 8.53853 13.6569 8.92905L8 14.5859L2.34315 8.92905C1.95262 8.53853 1.31946 8.53853 0.928933 8.92905C0.538408 9.31958 0.538408 9.95274 0.928933 10.3433L7.29289 16.7072ZM7 0.000122114L7 16.0001L9 16.0001L9 0.000122027L7 0.000122114Z" fill="#80AC58"/></svg><br>или норма</td><td style="text-align:center"><svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.79289 16.7072C7.18342 17.0978 7.81658 17.0978 8.20711 16.7072L14.5711 10.3433C14.9616 9.95274 14.9616 9.31958 14.5711 8.92905C14.1805 8.53853 13.5474 8.53853 13.1569 8.92905L7.5 14.5859L1.84315 8.92905C1.45262 8.53853 0.819456 8.53853 0.428932 8.92905C0.0384074 9.31958 0.0384074 9.95274 0.428932 10.3433L6.79289 16.7072ZM6.5 0.000122027L6.5 16.0001L8.5 16.0001L8.5 0.000122114L6.5 0.000122027Z" fill="#3C4242"/></svg></td><td style="text-align:center"><svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.79289 16.7072C7.18342 17.0978 7.81658 17.0978 8.20711 16.7072L14.5711 10.3433C14.9616 9.95274 14.9616 9.31958 14.5711 8.92905C14.1805 8.53853 13.5474 8.53853 13.1569 8.92905L7.5 14.5859L1.84315 8.92905C1.45262 8.53853 0.819456 8.53853 0.428932 8.92905C0.0384074 9.31958 0.0384074 9.95274 0.428932 10.3433L6.79289 16.7072ZM6.5 0.000122027L6.5 16.0001L8.5 16.0001L8.5 0.000122114L6.5 0.000122027Z" fill="#3C4242"/></svg>&nbsp; или норма &nbsp;<svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.20711 0.293015C7.81658 -0.0975094 7.18342 -0.0975094 6.79289 0.293015L0.428932 6.65698C0.0384079 7.0475 0.0384079 7.68067 0.428932 8.07119C0.819457 8.46171 1.45262 8.46171 1.84315 8.07119L7.5 2.41434L13.1569 8.07119C13.5474 8.46171 14.1805 8.46171 14.5711 8.07119C14.9616 7.68067 14.9616 7.0475 14.5711 6.65698L8.20711 0.293015ZM8.5 17.0001L8.5 1.00012L6.5 1.00012L6.5 17.0001L8.5 17.0001Z" fill="#3C4242"/></svg></td><td style="text-align:center">норма</td></tr><tr><td style="text-align:center">Паратгормон в крови</td><td style="text-align:center;color:#80ac58"><svg class="d-inline" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.29289 16.7072C7.68342 17.0978 8.31658 17.0978 8.70711 16.7072L15.0711 10.3433C15.4616 9.95274 15.4616 9.31958 15.0711 8.92905C14.6805 8.53853 14.0474 8.53853 13.6569 8.92905L8 14.5859L2.34315 8.92905C1.95262 8.53853 1.31946 8.53853 0.928933 8.92905C0.538408 9.31958 0.538408 9.95274 0.928933 10.3433L7.29289 16.7072ZM7 0.000122114L7 16.0001L9 16.0001L9 0.000122027L7 0.000122114Z" fill="#80AC58"/></svg><br>или норма</td><td style="text-align:center"><svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.20711 0.293015C7.81658 -0.0975094 7.18342 -0.0975094 6.79289 0.293015L0.428932 6.65698C0.0384079 7.0475 0.0384079 7.68067 0.428932 8.07119C0.819457 8.46171 1.45262 8.46171 1.84315 8.07119L7.5 2.41434L13.1569 8.07119C13.5474 8.46171 14.1805 8.46171 14.5711 8.07119C14.9616 7.68067 14.9616 7.0475 14.5711 6.65698L8.20711 0.293015ZM8.5 17.0001L8.5 1.00012L6.5 1.00012L6.5 17.0001L8.5 17.0001Z" fill="#3C4242"/></svg></td><td style="text-align:center"><svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.20711 0.293015C7.81658 -0.0975094 7.18342 -0.0975094 6.79289 0.293015L0.428932 6.65698C0.0384079 7.0475 0.0384079 7.68067 0.428932 8.07119C0.819457 8.46171 1.45262 8.46171 1.84315 8.07119L7.5 2.41434L13.1569 8.07119C13.5474 8.46171 14.1805 8.46171 14.5711 8.07119C14.9616 7.68067 14.9616 7.0475 14.5711 6.65698L8.20711 0.293015ZM8.5 17.0001L8.5 1.00012L6.5 1.00012L6.5 17.0001L8.5 17.0001Z" fill="#3C4242"/></svg></td><td style="text-align:center">норма</td></tr><tr><td style="text-align:center">Витамин D в крови</td><td style="text-align:center;color:#80ac58">норма<br>(в некоторых<br>случаях ниже<br>нормы)</td><td style="text-align:center"><svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.79289 16.7072C7.18342 17.0978 7.81658 17.0978 8.20711 16.7072L14.5711 10.3433C14.9616 9.95274 14.9616 9.31958 14.5711 8.92905C14.1805 8.53853 13.5474 8.53853 13.1569 8.92905L7.5 14.5859L1.84315 8.92905C1.45262 8.53853 0.819456 8.53853 0.428932 8.92905C0.0384074 9.31958 0.0384074 9.95274 0.428932 10.3433L6.79289 16.7072ZM6.5 0.000122027L6.5 16.0001L8.5 16.0001L8.5 0.000122114L6.5 0.000122027Z" fill="#3C4242"/></svg></td><td style="text-align:center"><svg class="d-inline" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.79289 16.7072C7.18342 17.0978 7.81658 17.0978 8.20711 16.7072L14.5711 10.3433C14.9616 9.95274 14.9616 9.31958 14.5711 8.92905C14.1805 8.53853 13.5474 8.53853 13.1569 8.92905L7.5 14.5859L1.84315 8.92905C1.45262 8.53853 0.819456 8.53853 0.428932 8.92905C0.0384074 9.31958 0.0384074 9.95274 0.428932 10.3433L6.79289 16.7072ZM6.5 0.000122027L6.5 16.0001L8.5 16.0001L8.5 0.000122114L6.5 0.000122027Z" fill="#3C4242"/></svg></td><td style="text-align:center">норма</td></tr></tbody></table></div>`,
            content_above: "",
            active: true,
            auth: false,
          },
          {
            title: "Почему ГФФ это жизнеугрожающее заболевание?",
            content: `<div class='text-1'>Низкий уровень ЩФ и деминерализация кости приводят к тяжелым клиническим проявлениям и прогрессированию ГФФ в течение жизни. Для новорожденных с ГФФ характерна высокая смертность: более 50% малышей с ГФФ умирают на первом году жизни.<sup>3</sup> Для детей и взрослых характерны прогрессирующее поражение скелета с рахитоподобными деформациями и системными инвалидизирующими проявлениями. 13 переломов в среднем насчитывается у пациента с ГФФ в течение жизни.<sup>4</sup></div>`,
            content_above: "",
            active: true,
            auth: false,
          },
          {
            title:
              "Можно ли назначать витамин D при рахитических проявлениях при ГФФ?",
            content: `<div class='text-1'>Пациентам с Гипофосфатазией не рекомендовано рутинное назначение препаратов витамина D: его избыток может вызвать или усугубить гиперкальциемию, гиперкальциурию и нефрокальциноз.<sup>2</sup></div>`,
            content_above: "",
            active: true,
            auth: false,
          },
          {
            title: "Какую роль играет щелочная фосфатаза при ГФФ?",
            content: `<div class='text-1'>Щелочная фосфатаза (ЩФ) – фермент, который необходим для создания полноценной костной ткани. При нормальной концентрации ЩФ в организме ЩФ отделяет от неорганического пирофосфата неорганический фосфат, который связывается с кальцием и образует кристаллы гидроксиапатита, необходимые для минерализации костей. При ГФФ мутация в гене ALPL приводит к снижению активности ЩФ. Фермент больше не может обеспечить эффективное отделение неорганического фосфата, нарушается процесс минерализации костной ткани. Это чревато деформациями костной ткани и полисистемными осложнениями.<sup>5</sup></div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Какие есть особенности определения ЩФ?",
            content: `<div class='text-1'>Для определения низкого уровня ЩФ необходимо использовать референтные интервалы ЩФ согласно возрасту и полу пациента.<sup>2</sup></div><br><br><div class="full-screen mb-6"><div class="full-screen__trigger d-xl-none"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="8" fill="#830051"></rect><path d="M23 11H29V17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17 29H11V23" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M29 11L22 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11 29L18 22" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div><img class="mb-4" src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/content/hpp/graph-1.jpg"></div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Какова распространенность заболевания?",
            content: `<div class='text-1'>В России ожидаемая распространенность ГФФ 1: 100 000 населения.<sup>6</sup></div>`,
            content_above: "",
            active: true,
          },
          {
            title: "В каком возрасте может возникнуть ГФФ?",
            content: `<div class='text-1'>ГФФ – врожденное заболевание, обусловленное мутациями гена ALPL. Симптомы ГФФ варьируются от раннего выпадения молочных зубов до 5 лет до тяжелых форм с инвалидизирующими изменениями конечностей и могут проявиться в любом возрасте в зависимости от формы заболевания<sup>7</sup>:<br><br> <strong>Перинатальная / Инфантильная</strong> — до 6 мес; <br><br> <strong>Ювенильная</strong> — от 6 мес. до 18 лет;<br><br> <strong>Взрослая</strong> — старше 18 лет;<br><br> <strong>Одонтогипофосфазия</strong> — при изолированном поражении зубов.</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Зачем нужна программа «скрининга» ГФФ?",
            content: `<div class='text-1'>Программа скрининга ГФФ была запущена в целях повышения выявляемости наследственных заболеваний обмена, в рамках которой врач может отправить всех пациентов, которым он хочет исключить такое жизнеугрожающее заболевание как гипофосфатазия на дообследование в сетевую лабораторию. Это особенно важно в условиях рутинного назначения витамина Д, прием которого не рекомендован при гипофосфатазии. Начиная с 2021 года, Гипофосфатазия входит в перечень заболеваний, обеспечиваемых за счет средств фонда Круг Добра.</div>`,
            content_above: "О программе",
            active: true,
          },
          {
            title:
              "Детей с рахитом много, каких направлять на диагностику ГФФ?",
            content: `<div class='text-1'>В рамках программы есть возможность направлять всех пациентов с рахитическими проявлениями и сниженным/неуточненным уровнем ЩФ на диагностику ГФФ.</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Что имеется в виду под рахитическими проявлениями?",
            content: `<div class='text-1'>Любые признаки рахита, такие как деформация скелета, мышечная гипотония, задержка в росте и развитии, рахитические деформации грудной клетки, неврологические проявления и т.д.</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Зачем исключать ГФФ, если нет жизнеугрожающих проявлений?",
            content: `<div class='text-1'>Жизнеугрожающие проявления ГФФ возникают на поздней стадии заболевания, когда процесс приобретает необратимый характер. Наличие же неустановленного диагноза Гипофосфатазия, как правило, приводит к прогрессированию осложнений в течение жизни – 13 переломов в среднем насчитывается у пациента с ГФФ<sup>4</sup>. Своевременно направляя пациентов на диагностику и исключая жизнеугрожающее заболевание на ранней стадии, Вы сможете предотвратить развитие губительных последствий, приводящих к тяжелой инвалидизации и преждевременной смерти пациентов.</div>`,
            content_above: "",
            active: true,
          },
          {
            title:
              "Как объяснить родителям, что пациента с рахитом/переломами мы дополнительно диагностируем на ГФФ?",
            content: `<div class='text-1'>Симптомы ГФФ варьируются от раннего выпадения молочных зубов до тяжелых форм с инвалидизирующими изменениями конечностей и могут проявляться в любом возрасте. Сейчас появилась возможность пройти бесплатное обследование всем пациентам с рахитическими проявлениями и/или необъяснимыми частыми переломами для того, чтобы навсегда исключить заболевание ГФФ.</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Какие анализы входят в программу скрининга ГФФ?",
            content: `<div class='text-1'>В рамках программы скрининга пациенту будет выполнено определение уровня щелочной фосфатазы. В случае обнаружения пониженного значения, будет проведен поиск изменений в гене ALPL.</div>`,
            content_above: "Об анализах",
            active: true,
          },
          {
            title: "Где пациент будет сдавать кровь на анализ?",
            content: `<div class='text-1'>В выделенных офисах ГЕМОТЕСТ.<br> Адреса отделений ГЕМОТЕСТ уточняйте на горячей линии ГЕМОТЕСТ 8-800-550-13-13, доб. 69777.</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Какие лаборатории будут проводить генетический анализ?",
            content: `<div class='text-1'>Генетический анализ на поиск изменений в гене LIPA будет проведен на базе федерального центра МГНЦ им. Бочкова.</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Как долго ожидать результаты анализа?",
            content: `<div class='text-1'>Определение уровня щелочной фосфатазы – до 3 дней <br> Поиск изменений в гене ALPL – до 1 мес.</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Как я узнаю о результате анализа?",
            content: `<div class='text-1'>Результаты анализа будут доступны пациенту по email, в ЛК ГЕМОТЕСТ или в отделении ГЕМОТЕСТ (при предъявлении документа, удостоверяющего личность).</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Что происходит после положительного результата анализа?",
            content: `<div class='text-1'>При положительном результате на ГФФ пациент будет проходить консультацию у врача-генетика ГЕМОТЕСТ.</div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Как лечат пациента с ГФФ?",
            content: `<div class='text-1'>Сегодня пациентам с ГФФ доступна патогенетическая терапия препаратом СТРЕНЗИК, которая продемонстрировала свою эффективность в клинических исследованиях, в которых приняли участие 99 пациентов в возрасте от 1 дня до 58 лет.<sup>8</sup></div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Как происходит обеспечение терапии?",
            content: `<div class='text-1'>Гипофосфатазия входит в перечень заболеваний, обеспечиваемых за счет средства фонда Круг Добра. После того как у пациента подтверждается диагноз необходимо инициировать заявку на бесплатное обеспечение в фонд Круг Добра.<sup>9, 10</sup></div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Список литературы",
            content: `<div class='text-1'><ol><li>Mornet E. Genetics of hypophosphatasia. Arch Pediatr. 2017 May;24(5S2):5S51-5S56. doi: 10.1016/S0929-693X(18)30014-9. PMID: 29405932</li><li>Проект КР, Нарушение обмена фосфора:<a href="https://www.pediatr-russia.ru/information/klin-rek/proekty-klinicheskikh-rekomendatsiy/" target="_blank">https://www.pediatr-russia.ru/information/klin-rek/proekty-klinicheskikh-rekomendatsiy/</a></li><li>Whyte M, et al. Hypophosphatasia: a retrospective natural history study of the severe perinatal and infantile forms. Poster presented at: Pediatric Academic Societies and Asian Society for Pediatric Research Joint Meeting; May 3-6, 2014; Vancouver, BC, Canada.</li><li>Weber TJ, et al. Burden of disease in adult patients with hypophosphatasia: Results from two patient-reported surveys. Metabolism. 2016;65(10):1522–1530. doi: 10.1016/j.metabol.2016.07.006.</li><li>Rockman-Greenberg C. Hypophosphatasia. Pediatr Endocrinol Rev. 2013 Jun;10 Suppl 2:380-8. PMID: 23858621</li><li>Баранов А. А. и др. Современные подходы к ведению пациентов с гипофосфатазией //Педиатрическая фармакология. – 2020 – Т. 17 – №. 6 – С. 519-528.</li><li>Whyte MP et al. Natural History of Perinatal and Infantile Hypophosphatasia: A Retrospective Study. J Pediatr. 2019 Jun;209:116-124.e4. doi: 10.1016/j.jpeds.2019.01.049.</li><li>Инструкция по медицинскому применению препарата Стрензик® регистрационный номер: ЛП-005666<a href="https://grls.rosminzdrav.ru/Grls_View_v2.aspx?routingGuid=2da0e810-ee51-4013-8e2b-ed6f71942dc6" target="_blank">https://grls.rosminzdrav.ru/Grls_View_v2.aspx?routingGuid=2da0e810-ee51-4013-8e2b-ed6f71942dc6</a> , дата обращения 27.03.2023.</li><li>Перечень заболеваний, фонд Круг Добра: <a href="https://фондкругдобра.рф/перечни/перечень-заболеваний/"  target="_blank">https://фондкругдобра.рф/перечни/перечень-заболеваний/</a></li><li>Перечень для закупок, фонд Круг Добра: <a href="https://фондкругдобра.рф/перечни/перечень-для-закупок" target="_blank">https://фондкругдобра.рф/перечни/перечень-для-закупок</a>/</li></ol></div>`,
            content_above: "",
            active: true,
          },
          {
            title: "Инструкция",
            content: `<div class="text-1"><strong>Регистрационный номер:</strong>&nbsp;ЛП-005666. Торговое название: СТРЕНЗИК<sup style="color:currentColor">&reg;</sup>.<br><br><strong>МНН:</strong>&nbsp;асфотаза альфа.<br><br><strong>Лекарственная форма:</strong>&nbsp;раствор для подкожного введения<br><br><strong>Состав:</strong>&nbsp;40 мг/мл; 100 мг/мл действующее вещество: асфотаза альфа 40 мг и 100 мг.<br><br><strong>Описание:</strong>&nbsp;бесцветная или желтоватая, прозрачная, слегка опалесцирующая или опалесцирующая жидкость, возможно наличие нескольких небольших полупрозрачных или белых частиц.<br><br><strong>Показания к применению:</strong>&nbsp;препарат Стрензик<sup style="color:currentColor">&reg;</sup>показан для длительной заместительной ферментной терапии пациентов с гипофосфатазией с началом в детском возрасте с целью купирования проявлений заболевания со стороны костей.<br><br><strong>Противопоказания:</strong>&nbsp;гиперчувствительность к асфотазе альфа и/или любому вспомогательному веществу в составе препарата.<br><br><strong>С осторожностью:</strong>&nbsp;в связи с недостаточностью данных препарат следует применять с осторожностью у пациентов с нарушением функции печени и почек, а также у пожилых пациентов. Применение во время беременности и в период грудного вскармливания. Какие-либо данные в отношении применения асфотазы альфа беременными женщинами отсутствуют. Данные исследований репродуктивной токсичности у животных недостаточны. Применение асфотазы альфа не рекомендуется во время беременности. Использование эффективных средств контрацепции должно быть предусмотрено для женщин с сохраненным репродуктивным потенциалом. Данных о проникновении асфотазы альфа в грудное молоко человека недостаточно. Следует принять решение либо по прекращению грудного вскармливания, либо прекратить терапию асфотазой альфа с учетом пользы грудного вскармливания для ребенка и необходимости терапии для женщины.<br><br><strong>Способ применения и дозы.</strong>&nbsp;Лечение препаратом Стрензик<sup style="color:currentColor">&reg;</sup>должно проводиться врачом, имеющим опыт терапии пациентов с метаболическими расстройствами или заболеваниями костей. Рекомендованный режим дозирования препарата: – 2 мг/кг асфотазы альфа подкожно 3 раза в неделю, либо 1 мг/кг асфотазы альфа 6 раз в неделю. Максимальная рекомендованная доза асфотазы альфа составляет 6 мг/кг массы тела/неделю. Более подробная информация представлена в полной версии инструкции.<br><br><strong>Способ введения:</strong>&nbsp;препарат Стрензик<sup style="color:currentColor">&reg;</sup>предназначен исключительно для подкожного введения. Не предназначен для внутривенного и внутримышечного введения. Максимальный объем вводимого за 1 инъекцию лекарственного препарата не должен превышать 1 мл. При необходимости введения объема более 1 мл допускается проведение нескольких инъекций в одно и то же время в разные места введения (бедра, живот, руки (дельтовидные мышцы), ягодицы).<br><br><strong>Побочное действие.</strong>&nbsp;Самыми распространенными наблюдаемыми нежелательными реакциями были реакции в месте введения и нежелательные реакции, связанные с инъекциями. Эти реакции были в основном несерьезными и имели степень тяжести от легкой до умеренной. Реакции в месте инъекции (включая атрофию в месте инъекции, абсцесс, эритему, изменение цвета, боль, зуд, пятно, отек, ушиб, синяк, липодистрофию (липоатрофия или липогипертрофия), уплотнение, реакцию, узелок, сыпь, папулу, гематому, воспаление, крапивницу, кальциноз, локальное повышение температуры, кровоизлияние, флегмона, рубец, новообразование, экстравазация, отшелушивание и пузырьки) являются наиболее частыми нежелательными реакциями, наблюдаемыми примерно у 74% пациентов в клинических исследованиях. Реакции гиперчувствительности включают эритему/покраснение, пиретическую реакцию/лихорадку, сыпь, зуд, раздражительность, тошноту, рвоту, болевые ощущения, дрожь/озноб, гипестезию ротовой полости, головную боль, гиперемию, тахикардию, кашель, а также симптомы, соответствующие анафилаксии. Было также получено несколько сообщений об анафилактоидных реакциях/реакциях повышенной чувствительности, для которых были характерны следующие симптомы: затрудненное дыхание, ощущение удушья, периорбитальный отек и головокружение. Препарат обладает потенциальной иммуногенностью.<br><br><strong>Передозировка.</strong>&nbsp;Опыт передозировки асфотазы альфа ограничен. Максимальная доза асфотазы альфа, используемая в клинических исследованиях, составляла 28 мг/кг/неделю. В клинических исследованиях не наблюдалось дозозависимой токсичности или изменения профиля безопасности. Таким образом, уровень передозировки не определен. Взаимодействие с другими лекарственными препаратами. Исследований взаимодействий с асфотазой альфа не проводилось. Основываясь на структуре и фармакокинетике, влияние асфотазы альфа на метаболизм, связанный с системой цитохрома Р-450, является маловероятным. Препарат не следует смешивать с другимилекарственными препаратами, так как исследования совместимости не проводились.<br><br><strong>Особые указания.</strong>&nbsp;Исследований по оценке генотоксического и канцерогенного потенциала асфотазы альфа не проводилось. В доклинических исследованиях фертильности не было выявлено какого-либо эффекта на фертильность и эмбриофетальное развитие (см. раздел «Применение при беременности и в период грудного вскармливания»). Асфотаза альфа содержит каталитический домен тканенеспецифической щелочной фосфатазы. При введении асфотазы альфа определение активности щелочной фосфатазы рутинными лабораторными методами не представляется возможным в связи с многократно завышенными результатами. Активность асфотазы альфа не следует интерпретировать по значениям активности щелочной фосфатазы, поскольку активность щелочной фосфатазы характеризуется различиями ферментных характеристик. Щелочную фосфатазу (ЩФ) применяют во многих стандартных лабораторных анализах в качестве реактива для детекции. При наличии асфотазы альфа в клинических лабораторных образцах измеряемые значения ЩФ могут значительно отклоняться от нормы. Лечащему врачу следует заблаговременно оповестить исследовательскую лабораторию, что пациент получает лечение препаратом, меняющим уровень активности ЩФ. Для пациентов, получающих лечение препаратом Стрензик®, возможно применение альтернативных методов анализа (т.е. систем, не основанных на ЩФ-конъюгированной системе детекции). При возникновении реакции гиперчувствительности рекомендуется немедленное прекращение лечения, и назначение соответствующей медикаментозной терапии. Следует соблюдать принятые в настоящее время стандарты оказания неотложной помощи. При необходимости повторного введения препарата пациенту после серьезной реакции гиперчувствительности, врач должен оценить риск и пользу от применения препарата, принимая во внимание другие факторы, которые могут влиять на развитие реакции гиперчувствительности, такие как сопутствующая инфекция и/или применение антибиотиков. Повторное назначение противопоказано при наличии тяжелых или потенциально жизнеугрожающих неконтролируемых реакций гиперчувствительности.<br><br><strong>Форма выпуска.</strong>&nbsp;Раствор для подкожного введения, 40 мг/мл, 100 мг/мл. Для дозировки 40 мг/мл: По 12 мг/0,3 мл; 8 мг/0,45 мл; 28 мг/0,7 мл; 40 мг/1,0 мл в стеклянный флакон гидролитического класса I вместимостью 2 или 3 мл, укупоренный бутилкаучуковой пробкой и алюминиевой крышкой с полипропиленовым откидным колпачком. Для дозировки 100 мг/мл: по 80 мг/0,8 мл в стеклянный флакон гидролитического класса I вместимостью 2 или 3 мл, укупоренный бутилкаучуковой пробкой и алюминиевой крышкой с полипропиленовым откидным колпачком.<br><br><strong>Условия хранения.</strong>&nbsp;В защищенном от света месте, при температуре от 2 до 8<sup style="color:currentColor">&deg;</sup>C, не замораживать! Хранить в недоступном для детей месте. Срок годности: 30 месяцев. Не применять по истечении срока годности.<br><br><strong>Условия отпуска.</strong>&nbsp;Отпускают по рецепту.<br><br><strong>Список литературы:</strong><br>1. Инструкция по медицинскому применению препарата СТРЕНЗИК<sup style="color:currentColor">&reg;</sup>(асфотаза альфа). Рег. номер ЛП ЛП-005666.<a href="https://grls.rosminzdrav.ru/grls.aspx?s=%D0%A1%D1%82%D1%80%D0%B5%D0%BD%D0%B7%D0%B8%D0%BA&m=tn" target="_blank">https://grls.rosminzdrav.ru/grls.aspx?s=%D0%A1%D1%82%D1%80%D0%B5%D0%BD%D0%B7%D0%B8%D0%BA&m=tn</a>Обращение от 11.11.2022.<br><br>Материал предназначен для специалистов здравоохранения. Имеются противопоказания.<br><br>Перед назначением, ознакомьтесь, пожалуйста, с полной инстукцией по медицинскому применению препарата.<br><br>Номер одобрения: STR-RU-14977. Дата одобрения: 11.11.2022. Дата истечения: 10.11.2024.</div>`,
            content_above: "",
            active: true,
          },
        ],
        banners: [
          {
            banner_mobile: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/hpp/lald/lald_375.jpg`,
            banner_tablet: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/hpp/lald/lald_768.jpg`,
            banner_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/hpp/lald/lald_1440.jpg`,
            banner_desktop_l: null,
            banner_desktop_xl: null,
            banner_desktop_xxl: null,
            title: "Гипофосфатазия:<br> Вопросы и ответы",
            description: "",
          },
        ],
        title: "Дефицит лизосомной кислой липазы: Вопросы и ответы",
        name: "О нозологии",
        color: "#830051",
        hash: "0da6fced0f150ef5fec90c4548e2f5fd4cf79600d776caf2005c7dfa91bc81a6",
      };
    },
  },
  methods: {
    medicationsClick(item) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "disease page medications click", {
          "disease page medications click": {
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(item.to).catch(() => {});
    },
    calendarClick(item) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "disease page events click", {
          "disease page events click": {
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(item.to).catch(() => {});
    },
    libClick(item, text) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "disease page library materails click", {
          "disease page library materails click": {
            "block name": text,
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(item.to).catch(() => {});
    },
    closePopup() {
      this.popup = false;
    },
    clickOpener() {
      this.popup = true;
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.materials {
  display: grid;

  margin-bottom: 40px;

  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }
}

.failure-page {
  &__categories {
    max-width: 800px;
  }
  &__row {
    display: grid;

    column-gap: 136px;
    grid-template-columns: 2fr 280px;
    @media screen and (max-width: 1220px) {
      grid-template-columns: 100%;
      row-gap: 40px;
    }
    .failure-page__aside {
      @media screen and (max-width: 1220px) {
        display: flex;
        overflow-x: auto;
        align-items: center;
        justify-content: flex-start;

        -ms-scroll-snap-type: x mandatory;
        scroll-snap-type: x mandatory;
      }
    }
  }
  &__section {
    padding-top: 64px;
  }
  &__title {
    margin-bottom: 40px;
    color: #1f1f1f;
    font-family: "Roboto Slab", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 42px;
    line-height: 48px;
    @media screen and (max-width: 767px) {
      font-size: 32px;
      line-height: 38px;
    }
  }
  // &__title_big {
  //   margin-bottom: 40px;
  //   color: #1f1f1f;
  //   font-family: "Roboto Slab", sans-serif;
  //   font-weight: 400;
  //   font-style: normal;
  //   font-size: 42px;
  //   line-height: 48px;
  //   @media screen and (max-width: 767px) {
  //     font-size: 32px;
  //     line-height: 38px;
  //   }
  // }
  &__description {
    color: #656969;

    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    line-height: 22px;
  }
}
</style>

<style lang="scss">
.gff .overflow {
  padding-bottom: 15px;
  overflow: auto;
  // -ms-overflow-style: scrollbar;
  // scrollbar-color: #005F5B transparent;
  // scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #005f5b;
    border-radius: 5px;
    height: 8px;
  }

  &::-webkit-scrollbar--track-piece {
    border-radius: 5px;
    background-color: #ebefee;
  }

  &::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #ebefee;
    border: 3px solid #fff;
  }

  &::-moz-scrollbar-button:decrement,
  &::-moz-scrollbar-button:increment,
  &::-moz-scrollbar-button:vertical:start:decrement,
  &::-moz-scrollbar-button:vertical:end:increment,
  &::-moz-scrollbar-button:horizontal:start:decrement,
  &::-moz-scrollbar-button:horizontal:end:increment,
  &::-webkit-scrollbar-button:vertical:start:decrement,
  &::-webkit-scrollbar-button:vertical:end:increment,
  &::-webkit-scrollbar-button:horizontal:start:decrement,
  &::-webkit-scrollbar-button:horizontal:end:increment {
    width: 0px !important;
    height: 0px !important;
  }
}
</style>
